import { get } from '../axios'
// 获取新闻
const getNewsData = (newsId) => {
  return get('/foshan/api/v2/getNewsDetailsBodyById', { newsId })
}

// 获取新闻
export const getCategoriesInfo = (specialSno = -1, cids = 0) => {
  return get(`/foshan/api/v2/categories/news?specialSno=${specialSno}&categoryIds=${cids}&count=5`)
}

// 获取新闻
export const getHotInfo = (specialSno = -1, cids = 0) => {
  return get(`/foshan/api/v2/getNewsList?specialSno=${specialSno}&cids=${cids}&count=5`)
}

// 获取新闻
export const getTopicInfo = (newsId) => {
  return get(`/foshan/api/v2/getTopicNewsList?newsId=${newsId}`)
}

// 获取类别
export const getPublishTypes = () => {
  return get('/activity/dict/getAllByPidOrderByTypeAndSno?pid=DEPUTY_CLASS')
}

export default {
  getNewsData,
  getCategoriesInfo,
  getHotInfo,
  getPublishTypes
}
